import React from 'react';
import { TopBanner } from '../components/TopBanner';
import { MainBookHero } from '../components/MainBookHero';
import { MobileCarousel } from '../components/MobileCarousel';
import { TransformationSlider } from '../components/TransformationSlider';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentPreview } from '../components/ContentPreview';
import { ResultsSection } from '../components/ResultsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ExpertEndorsement } from '../components/ExpertEndorsement';
import { BundleOfferSection } from '../components/BundleOfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-black text-white selection:bg-gold-500 selection:text-black" data-id="element-633">
      <TopBanner data-id="element-634" />

      {/* PARTE 1: PROMOCIÓN DEL EBOOK PRINCIPAL */}
      <MainBookHero data-id="element-635" />
      <TransformationSlider data-id="element-636" />
      <ProblemSection data-id="element-637" />
      <SolutionSection data-id="element-638" />
      <ContentPreview data-id="element-639" />
      <ResultsSection data-id="element-640" />
      <TestimonialsSection data-id="element-641" />
      <ExpertEndorsement data-id="element-642" />

      {/* Mobile-only carousel - Luxury compact design */}
      <MobileCarousel data-id="element-643" />

      {/* PARTE 2: OFERTA DEL PACK COMPLETO (7 EBOOKS) */}
      <BundleOfferSection data-id="element-644" />

      <GuaranteeSection data-id="element-645" />
      <FAQSection data-id="element-646" />
      <FinalCTA data-id="element-647" />
      <Footer data-id="element-648" />
    </div>;
}